import { RequestModel } from './request.model';
import { AlternativeRequestDTO, AlternativeRequestProduct } from '@core/types';

export class AlternativeRequestModel extends RequestModel {
  alternativeProducts: AlternativeRequestProduct[];

  constructor(request: AlternativeRequestDTO) {
    super(request);
    this.alternativeProducts = [...(request.alternativeProducts ?? [])];
  }
}
